export const StarFullSmallIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8579_99513)">
      <path
        d="M7.00035 10.0761L9.42118 11.5403C9.86451 11.8086 10.407 11.412 10.2903 10.9103L9.64868 8.15698L11.7895 6.30198C12.1803 5.96365 11.9703 5.32198 11.457 5.28115L8.63951 5.04198L7.53701 2.44031C7.33868 1.96781 6.66201 1.96781 6.46368 2.44031L5.36118 5.03615L2.54368 5.27531C2.03035 5.31615 1.82035 5.95781 2.21118 6.29615L4.35201 8.15115L3.71035 10.9045C3.59368 11.4061 4.13618 11.8028 4.57951 11.5345L7.00035 10.0761Z"
        fill="#FAAD14"
      />
    </g>
    <defs>
      <clipPath id="clip0_8579_99513">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
